export function HeaderController(
    $state,
    AuthenticationService,
    googleAnalyticsTrackingService,
    loginModalService,
    orderInfoService,
    paymentService,
    restaurantInfoFactory
) {
    'ngInject';
    var vm = this;
    vm.restaurantInfo = {};
    vm.$state = $state;
    vm.loginModal = loginModalService;
    vm.buyGCEvent = googleAnalyticsTrackingService.getBuyGCEvent();
    vm.checkAddGCEvent = googleAnalyticsTrackingService.getCheckAddGCEvent();
    vm.facebookLinkClickEvent = googleAnalyticsTrackingService.getFacebookLinkClickEvent();
    vm.twitterLinkClickEvent = googleAnalyticsTrackingService.getTwitterLinkClickEvent();
    vm.menuEvent = googleAnalyticsTrackingService.getMenuEvent();
    vm.openMenuEvent = googleAnalyticsTrackingService.getOpenMenuEvent();
    vm.loginSuccessCallback = () => {
        closeMenu();
        googleAnalyticsTrackingService.trackLoginSuccess();
    };
    vm.loginErrorCallback = errorMessage => googleAnalyticsTrackingService.trackLoginError(errorMessage);
    vm.forgotPasswordCallback = () => googleAnalyticsTrackingService.trackForgotPassword();
    vm.sendInstructionsCallback = () => googleAnalyticsTrackingService.trackSendInstructions();
    vm.forgotPasswordSuccessCallback = () => closeMenu();
    vm.createAccountSuccessCallback = () => {
        closeMenu();
        googleAnalyticsTrackingService.trackCreateAccountSuccess();
    };
    vm.createAccountErrorCallback = errorMessage => googleAnalyticsTrackingService.trackCreateAccountError(errorMessage);
    vm.logoutCallback = () => {
        paymentService.clearCreditCardPayment();
        orderInfoService.clearAllData();
    };
    vm.termsOfServiceCallback = () => googleAnalyticsTrackingService.trackTermsOfService();
    vm.privacyPolicyCallback = () => googleAnalyticsTrackingService.trackPrivacyPolicy();
    activate();

    ///---------------------

    function activate() {
        restaurantInfoFactory.getInfo(['general', 'imageSet', 'restaurantAddress', 'onlineOrder']).then(setRestaurantInfo);
        vm.authenticationService = AuthenticationService;
    }

    function setRestaurantInfo(info) {
        vm.restaurantInfo = info;
    }

    function closeMenu() {
        vm.loginModal.close();
    }
}
